import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetProcessingQuery,
  usePublicGetProcessingQuery,
  useGetProcessingEntriesQuery,
  usePublicGetProcessingEntriesQuery,
  useGetProcessingEntriesDefaultsQuery,
  usePublicGetProcessingEntriesDefaultsQuery,
  useUpdateProcessingsMutation,
  useCreateProcessingEntryMutation,
  useUpdateProcessingEntryMutation,
  useDeleteProcessingEntryMutation
} from '../features/modules/processingApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting processing data based on the current route.
 */
export const useContextAwareGetProcessing = createContextAwareHook(
  useGetProcessingQuery,
  usePublicGetProcessingQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting processing entries based on the current route.
 */
export const useContextAwareGetProcessingEntries = createContextAwareHook(
  useGetProcessingEntriesQuery,
  usePublicGetProcessingEntriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting processing entries defaults based on the current route.
 */
export const useContextAwareGetProcessingEntriesDefaults = createContextAwareHook(
  useGetProcessingEntriesDefaultsQuery,
  usePublicGetProcessingEntriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateProcessingsMutation,
  useCreateProcessingEntryMutation,
  useUpdateProcessingEntryMutation,
  useDeleteProcessingEntryMutation
}; 